var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWheel = function SvgWheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.56 7.119a8.998 8.998 0 0 1 .002 9.763M15.547 8.452a5.017 5.017 0 1 1-7.095 7.095 5.017 5.017 0 0 1 7.095-7.095",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.32 7.55 2.584-3.138a1.003 1.003 0 0 1 1.483-.072l1.273 1.273a1.002 1.002 0 0 1-.072 1.483L16.45 9.68M9.679 16.45l-2.584 3.138a1.003 1.003 0 0 1-1.483.072l-1.273-1.273a1.002 1.002 0 0 1 .072-1.483L7.55 14.32M7.55 9.68 4.41 7.094a1.003 1.003 0 0 1-.072-1.483L5.611 4.34a1.002 1.002 0 0 1 1.483.072l2.584 3.14M16.45 14.321l3.138 2.584c.457.376.49 1.064.072 1.483l-1.273 1.273a1.002 1.002 0 0 1-1.483-.072L14.32 16.45",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.882 19.561a8.998 8.998 0 0 1-9.763 0M4.439 7.118a8.998 8.998 0 0 0 0 9.763M16.88 4.44a8.998 8.998 0 0 0-9.763-.001",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWheel;